import dayjs from "dayjs";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import PromocodesApi from "../../../../api/promocodesApi";
import SpecialistApi from "../../../../api/specialistsApi";
import Input from "../../../../components/Input/Input";
import MuiDatePicker from "../../../../components/MuiDatePicker/MuiDatePicker";
import MuiSwitch from "../../../../components/MuiSwitch/MuiSwitch";
import MultipleSelect from "../../../../components/MultipleSelect/MultipleSelect";
import StandartButton from "../../../../components/StandartButton/StandartButton";
import { ISO639Lang } from "../../../../constans/languagesList";
import { siteLangs } from "../../../../constans/siteLangs";
import {
  DiscountPromocode,
  NewDiscountPromocode,
  PromocodeType,
} from "../../../../types/Promocodes";
import Notify, { SuccesNotify } from "../../../../utils/toaster";
import { parseNumberInRange } from "../../../FlexPass/flexPassUtils";
import { isValidPromocode } from "../promocodesUtils";
import s from "./CreatePromocode.module.css";
import FlexPassPromocode from "./FlexPassPromocode/FlexPassPromocode";
import PromocodeSelection from "./PromocodeSelection/PromocodeSelection";

type DropDownMenuData = { lable: string; value: string };

export type SelectFieldsPromocodeData = {
  languages: DropDownMenuData[];
  mainSpecializations: DropDownMenuData[];
  levels: DropDownMenuData[];
  types: DropDownMenuData[];
  topic: DropDownMenuData[];
};

const initialNewPromocode = {
  code: undefined,
  startDate: new Date(),
  endDate: new Date(),
  quantity: 1,
  quantityPerUser: 1,
  description: undefined,
  discount: {},
  type: "" as PromocodeType,
  selectionCombinations: undefined,
  onlyTalziExpense: false,
};

type CreatePromocodeProps = {
  setPromocodes: Dispatch<SetStateAction<DiscountPromocode[]>>;
  setCreatePromocodeModal: Dispatch<SetStateAction<boolean>>;
  setSelectedPromocode: Dispatch<SetStateAction<DiscountPromocode | undefined>>;
  isUpdatePromocode?: boolean;
  promocodePropsData?: DiscountPromocode;
};

const CreatePromocode = ({
  setPromocodes,
  setCreatePromocodeModal,
  setSelectedPromocode,
  isUpdatePromocode,
  promocodePropsData,
}: CreatePromocodeProps) => {
  const token = localStorage.getItem("token");
  const [promocodeData, setPromocodeData] =
    useState<NewDiscountPromocode>(initialNewPromocode);
  const [selectFieldsData, setSelectFieldsData] =
    useState<SelectFieldsPromocodeData>({
      languages: [],
      mainSpecializations: [],
      levels: [],
      types: [],
      topic: [],
    });

  const [enableCustomCode, setEnableCustomCode] = useState(false);
  const [intermediateData, setIntermediateData] = useState({
    quantity:
      promocodeData.quantity !== undefined
        ? promocodeData.quantity.toString()
        : "",
    quantityPerUser: promocodeData.quantityPerUser
      ? promocodeData.quantityPerUser.toString()
      : "",
    amount:
      promocodeData.discount.amount !== undefined
        ? promocodeData.discount.amount.toString()
        : "",
    percentage:
      promocodeData.discount.percentage !== undefined
        ? promocodeData.discount.percentage.toString()
        : "",
  });
  const [loaders, setloaders] = useState({ createLoader: false });

  const getMainSpecializations = async () => {
    if (!token) return;
    const response = await SpecialistApi.getMainSpecializations(token);
    if (response.status && response.mainSpecializations) {
      setSelectFieldsData((prev) => ({
        ...prev,
        mainSpecializations: response.mainSpecializations!.map((item) => ({
          lable: item.specialization,
          value: item._id,
        })),
      }));
    }
  };
  useEffect(() => {
    getMainSpecializations();
    setSelectFieldsData((prev) => ({
      ...prev,
      languages: siteLangs.map((item) => ({
        lable: ISO639Lang[item.value],
        value: item.value,
      })),
      types: [
        {
          value: PromocodeType.SELECTION,
          lable: "Selection",
        },
        {
          value: PromocodeType.SUBSCRIBTION,
          lable: "FlexPass",
        },
      ],
    }));
  }, []);

  useEffect(() => {
    if (!promocodePropsData) return;

    setPromocodeData({
      code: promocodePropsData.code,
      discount: {
        amount:
          promocodePropsData.discount.amount &&
          promocodePropsData.discount.amount / 100,
        percentage: promocodePropsData.discount.percentage,
      },
      endDate: new Date(promocodePropsData.endDate),
      startDate: new Date(promocodePropsData.startDate),
      onlyTalziExpense: promocodePropsData.onlyTalziExpense,
      quantity: promocodePropsData.quantity,
      type: promocodePropsData.type,
      selectionCombinations:
        promocodePropsData.selectionCombinations &&
        promocodePropsData.selectionCombinations.map((item) => ({
          direction: item.direction,
          language: item.language,
          level: item.level._id,
          mainSpecialization: item.mainSpecialization._id,
          topic: item.topic._id,
        })),
      subscriptions: promocodePropsData.subscriptions
        ? promocodePropsData.subscriptions.map((item) => item._id)
        : undefined,
      quantityPerUser: promocodePropsData.quantityPerUser,
      description: promocodePropsData.description,
    });
    setIntermediateData({
      quantity:
        promocodePropsData.quantity !== undefined
          ? promocodePropsData.quantity.toString()
          : "",
      amount:
        promocodePropsData.discount.amount !== undefined
          ? (promocodePropsData.discount.amount / 100).toString()
          : "",
      percentage:
        promocodePropsData.discount.percentage !== undefined
          ? promocodePropsData.discount.percentage.toString()
          : "",
      quantityPerUser: promocodePropsData.quantityPerUser
        ? promocodePropsData.quantityPerUser.toString()
        : "",
    });
  }, [promocodePropsData]);

  useEffect(() => {
    setPromocodeData((prev) => ({
      ...prev,
      selectionCombinations:
        promocodeData.type === PromocodeType.SELECTION
          ? prev.selectionCombinations
          : undefined,
      subscriptions:
        promocodeData.type === PromocodeType.SUBSCRIBTION
          ? prev.subscriptions
          : undefined,
    }));
  }, [promocodeData.type]);

  const createPromocode = async () => {
    if (!token) return;
    setloaders((prev) => ({ ...prev, createLoader: true }));
    const response = await PromocodesApi.createDiscountPromocode(token, {
      ...promocodeData,
      discount: {
        ...promocodeData.discount,
        amount: promocodeData.discount.amount
          ? promocodeData.discount.amount * 100
          : undefined,
      },
    });

    setloaders((prev) => ({ ...prev, createLoader: false }));
    if (response.status && response.promocode) {
      setPromocodes((prev) => [response.promocode!, ...prev]);
      setCreatePromocodeModal(false);
      SuccesNotify("Promocode has been created");
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  const updatePromocode = async () => {
    if (!token || !promocodePropsData) return;
    setloaders((prev) => ({ ...prev, createLoader: true }));
    const response = await PromocodesApi.updateDiscountPromocode(token, {
      ...promocodeData,
      _id: promocodePropsData._id,
      discount: {
        ...promocodeData.discount,
        amount: promocodeData.discount.amount
          ? promocodeData.discount.amount * 100
          : undefined,
      },
    });
    setloaders((prev) => ({ ...prev, createLoader: false }));
    if (response.status && response.promocode) {
      setPromocodes((prev) => {
        return prev.map((item) => {
          if (item._id === promocodePropsData._id) {
            return response.promocode!;
          }
          return item;
        });
      });
      setSelectedPromocode(response.promocode);
      setCreatePromocodeModal(false);
      SuccesNotify("Promocode has been updated");
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  return (
    <div className={s.container}>
      <h2 className={s.headTitle}>
        {isUpdatePromocode ? "Update Promocode" : "Create Promocode"}
      </h2>
      <div>
        <MuiSwitch
          checked={enableCustomCode}
          setChecked={(value) => {
            setEnableCustomCode(value);
            if (!value) {
              setPromocodeData((prev) => ({ ...prev, code: undefined }));
            }
          }}
          lable="Enter custom code"
        />
        <Input
          inputValue={promocodeData.code ?? ""}
          onChangeInput={(value) =>
            setPromocodeData((prev) => ({ ...prev, code: value.toUpperCase() }))
          }
          lable="Code"
          disabled={!enableCustomCode}
        />
      </div>
      <div className={s.section}>
        <span className={s.sectionTitle}>Description</span>
        <textarea
          className={s.descriptionTextarea}
          value={promocodeData.description ?? ""}
          onChange={(e) =>
            setPromocodeData((prev) => ({
              ...prev,
              description: e.target.value,
            }))
          }
          placeholder={`Enter description in ...`}
          rows={4}
        />
      </div>
      <div className={s.inputsRow}>
        <Input
          inputValue={intermediateData.quantityPerUser}
          onChangeInput={(value: string) => {
            if (parseNumberInRange(value, 0, 999999)) {
              setIntermediateData((prev) => ({
                ...prev,
                quantityPerUser: value,
              }));
              if (!isNaN(Number(value)) && value !== "." && value !== "") {
                setPromocodeData((prev) => ({
                  ...prev,
                  quantityPerUser: Number(value),
                }));
              }
            }
          }}
          lable="Quantity Per User"
          width="25%"
        />
        <Input
          inputValue={intermediateData.quantity}
          onChangeInput={(value: string) => {
            if (parseNumberInRange(value, 0, 999999)) {
              setIntermediateData((prev) => ({
                ...prev,
                quantity: value,
              }));
              if (!isNaN(Number(value)) && value !== "." && value !== "") {
                setPromocodeData((prev) => ({
                  ...prev,
                  quantity: Number(value),
                }));
              }
            }
          }}
          lable="Quantity"
          width="25%"
        />
        <div style={{ width: "25%" }}>
          <MuiDatePicker
            setValue={(value) => {
              setPromocodeData((prev) => ({
                ...prev,
                startDate: value ? value.toDate() : new Date(),
              }));
            }}
            value={dayjs(promocodeData.startDate)}
            label="Start date"
          />
        </div>
        <div style={{ width: "25%" }}>
          <MuiDatePicker
            setValue={(value) => {
              setPromocodeData((prev) => ({
                ...prev,
                endDate: value ? value.toDate() : new Date(),
              }));
            }}
            value={dayjs(promocodeData.endDate)}
            label="End date"
          />
        </div>
      </div>
      <div className={s.inputsRow}>
        <Input
          inputValue={intermediateData.amount}
          onChangeInput={(value: string) => {
            if (parseNumberInRange(value, 0, 999999)) {
              setIntermediateData((prev) => ({
                ...prev,
                amount: value,
                percentage: "",
              }));
              if (!isNaN(Number(value)) && value !== "." && value !== "") {
                setPromocodeData((prev) => ({
                  ...prev,
                  discount: {
                    percentage: undefined,
                    amount: Number(value),
                  },
                }));
              }
            }
          }}
          lable="Discount amount($)"
          width="25%"
        />
        <Input
          inputValue={intermediateData.percentage}
          onChangeInput={(value: string) => {
            if (parseNumberInRange(value, 0, 100)) {
              setIntermediateData((prev) => ({
                ...prev,
                percentage: value,
                amount: "",
              }));
              if (!isNaN(Number(value)) && value !== "." && value !== "") {
                setPromocodeData((prev) => ({
                  ...prev,
                  discount: {
                    amount: undefined,
                    percentage: Number(value),
                  },
                }));
              }
            }
          }}
          lable="Discount percentage(%)"
          width="25%"
        />
        <MultipleSelect
          data={selectFieldsData.types}
          setValue={(value) =>
            setPromocodeData((prev) => ({
              ...prev,
              type: value as PromocodeType,
            }))
          }
          value={promocodeData.type}
          multiplie={false}
          lable="Type"
          width="25%"
        />
        <div style={{ width: "25%" }}>
          <MuiSwitch
            checked={promocodeData.onlyTalziExpense}
            setChecked={(value) => {
              setPromocodeData((prev) => ({
                ...prev,
                onlyTalziExpense: value,
              }));
            }}
            lable="Only Talzi Expense"
          />
        </div>
      </div>
      {promocodeData.type === PromocodeType.SELECTION && (
        <PromocodeSelection
          promocodeData={promocodeData}
          selectFieldsData={selectFieldsData}
          setPromocodeData={setPromocodeData}
          setSelectFieldsData={setSelectFieldsData}
          defaultSelectionData={promocodePropsData?.selectionCombinations}
        />
      )}
      {promocodeData.type === PromocodeType.SUBSCRIBTION && (
        <FlexPassPromocode
          setPromocodeData={setPromocodeData}
          promocodePropsData={promocodePropsData}
        />
      )}
      <div className={s.actionBlock}>
        <StandartButton
          action={isUpdatePromocode ? updatePromocode : createPromocode}
          buttonTitle={"Save"}
          width="200px"
          disabled={loaders.createLoader || !isValidPromocode(promocodeData)}
        />
      </div>
    </div>
  );
};

export default CreatePromocode;
